import angular from "angular";

angular
	.module('app')
	.component('dfSetUserModal', {
		template: require('./df-set-user-modal.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.fullName = null;
	$ctrl.role = null;
	$ctrl.users = [];

	$ctrl.$onInit = function () {
    };

	$ctrl.addUser = () => {
	    let newUser = {
	        full_name: $ctrl.fullName,
            role: $ctrl.role,
        }
        $ctrl.users.push(newUser);
	    $ctrl.fullName = null;
	    $ctrl.role = null;
    };

	$ctrl.deleteUser = (index) => {
		let per = confirm("Вы точно хотите удалить члена комиссии?");
		if (per)
			$ctrl.users.splice(index, 1);
	}

	$ctrl.createWordDocument = () => {
		let url = '/df/applications/' + $ctrl.resolve.applicationId + '/create-word-document';
		let params = {
			users: $ctrl.users,
		}
		$http.post(url, params).then((res) => {
			$ctrl.close({
				$value: {
					word_path: res.data.word_path,
				}
			});
		}, (error) => {
            let checked = false;
            let message = '';
            angular.forEach(error.data.errors, function (value, key){
                if (!checked) {
                    message += value[0];
                    checked = true;
                }
            });
            if (message.length) {
                window.Swal.fire({
                    icon: 'error',
                    title: message,
                })
            } else {
                alert("Не известная ошибка обратитесь к администраций сайта");
            }
        });
	}
}
